import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("root");

// Pages are pre-rendered at build time (see scripts/prerender.js) so that
// crawlers which do not execute JavaScript still receive full HTML. When that
// markup is present we hydrate it instead of throwing it away and re-rendering,
// which keeps the first paint intact and avoids a visible flash.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// For performance metrics
reportWebVitals();
